<template>
    <v-loading-button :class-name="className" :prevent-default="preventDefault" :loading="loading" @clicked="clicked">
        <slot></slot>
    </v-loading-button>
</template>

<script>

    import LoadingButton from './LoadingButton';
    import mixin from './button-mixin.js';

    export default {
        components: {
            'v-loading-button': LoadingButton
        },
        mixins: [mixin],
        props: {
            color: {
                type: String,
                default: 'text-gray-600 hover:text-red'
            }
        }
    }
</script>
